import * as React from "react";
import styled from "styled-components";
import { ArrowIcon, PreviousIcon } from "./PreviousButton";

const NextIcon = styled(PreviousIcon)`
  svg {
    transform: rotate(-90deg);
  }
`;

export const NextButton = props => (
  <NextIcon {...props}>
    <ArrowIcon {...props} />
  </NextIcon>
);
